import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { NotificationProvider } from './context/NotificationContext';
import { WalletProvider } from './context/WalletContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import BottomNav from './components/layout/BottomNav';
import NotificationHost from './components/common/Notification';
import Loader from './components/common/Loader';

import LandingPage from './pages/LandingPage';
import DashboardPage from './pages/DashboardPage';
import RegisterPage from './pages/RegisterPage';
import InvestPage from './pages/InvestPage';
import WithdrawPage from './pages/WithdrawPage';
import TeamPage from './pages/TeamPage';
import ActivityPage from './pages/ActivityPage';
import AdminPage from './pages/AdminPage';
import XTTokenPage from './pages/XTTokenPage';
import NotFoundPage from './pages/NotFoundPage';

import './styles/theme.css';
import './styles/global.css';
import './styles/animations.css';

export default function App() {
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    // Brief loader on initial mount to show the WOW loader
    const t = setTimeout(() => setBooting(false), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <NotificationProvider>
      <BrowserRouter>
        <WalletProvider>
          {booting && <Loader label="INITIALIZING" />}
          <Navbar />
          <NotificationHost />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/invest" element={<InvestPage />} />
              <Route path="/withdraw" element={<WithdrawPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/activity" element={<ActivityPage />} />
              <Route path="/xt-token" element={<XTTokenPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
          <BottomNav />
        </WalletProvider>
      </BrowserRouter>
    </NotificationProvider>
  );
}
